import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetCoOwnerSharesProps = {
  partnerId: string;
  page: number;
  items: number;
  searchTerm?: string | number;
  sortBy?: string;
  sortOrder?: string;
};

export const getCoOwnerShares =
  ({ ...params }: GetCoOwnerSharesProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { ...params } };

    try {
      const { data } = await axiosV2.get('/shares/coOwners', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
